import { useEffect } from "react";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Solutions } from "@/components/site/Solutions";
import { Calculator } from "@/components/site/Calculator";
import { Process } from "@/components/site/Process";
import { Projects } from "@/components/site/Projects";
import { WhyUs } from "@/components/site/WhyUs";
import { AppDownload } from "@/components/site/AppDownload";
import { Footer } from "@/components/site/Footer";
import { ChatWidget } from "@/components/site/ChatWidget";
import { InstallBanner } from "@/components/site/InstallBanner";
import { scrollToId } from "@/lib/content";
import "@/lib/pwa";

export default function Landing() {
  // Arrivo dal QR code: porta direttamente alla sezione di installazione
  useEffect(() => {
    if (new URLSearchParams(window.location.search).has("installa")) setTimeout(() => scrollToId("app"), 400);
  }, []);
  return (
    <div data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <About />
        <Solutions />
        <Calculator />
        <Process />
        <Projects />
        <WhyUs />
        <AppDownload />
      </main>
      <Footer />
      <ChatWidget />
      <InstallBanner />
    </div>
  );
}
